import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

export function PerformerTable({ performers, canModify = false }) {
  const total = performers.length;

  return (
    <>
      <div className="manage-table-container">
        <table className="manage-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Performer</th>
              <th>Type</th>
              <th>Hometown</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {total === 0 ? (
              <tr>
                <td
                  colSpan={5}
                  className="py-10 text-center text-[var(--muted-foreground)]"
                >
                  {canModify
                    ? 'No performers yet. Add your first performer to get started.'
                    : 'No performers yet.'}
                </td>
              </tr>
            ) : (
              performers.map((performer) => (
                <tr key={performer.performerId}>
                  <td>
                    {performer.photoURL ? (
                      <img
                        src={performer.photoURL}
                        alt=""
                        className="event-thumb"
                      />
                    ) : (
                      <span
                        className="event-thumb inline-block bg-[var(--muted)]"
                        aria-hidden
                      />
                    )}
                  </td>
                  <td>
                    <strong className="text-[#121212]">
                      {performer.performerName}
                    </strong>
                  </td>
                  <td>{performer.type || '—'}</td>
                  <td>{performer.hometown || '—'}</td>
                  <td>
                    <div className="manage-actions">
                      <Link
                        to={`/performer/${performer.performerId}/view`}
                        className="bethere-action-btn"
                        title="View"
                        aria-label={`View ${performer.performerName}`}
                      >
                        <FontAwesomeIcon icon={['fas', 'eye']} />
                      </Link>
                      {canModify && (
                        <Link
                          to={`/performer/${performer.performerId}`}
                          className="bethere-action-btn"
                          title="Edit"
                          aria-label={`Edit ${performer.performerName}`}
                        >
                          <FontAwesomeIcon icon={['fas', 'pen-to-square']} />
                        </Link>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {total > 0 && (
        <div className="section-header-bethere mt-6 flex flex-wrap items-center justify-between gap-4">
          <p className="m-0 text-sm text-[var(--muted-foreground)]">
            Showing 1 to {total} of {total} Performers
          </p>
        </div>
      )}
    </>
  );
}
